export default __webpack_public_path__ + "static/hosting-shape4-828658b48bd3f965b11b93f1d176d267.png";